import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    tabs_status: {},
    step: 'identificacion_necesidad',
    tipo_prospecto: 'Lead',
    prospecto: {
        v_inventario: '',
        clientes: {
            nombre: '',
            apellido: '',
            celular: '',
            email: '',
            ubicacion: '',
        }
    },
    asesor: {
        meta_keys: {
            nombre: '',
            apellido: ''
        }
    },
    negocios: [],
    citas: [],
    tareas: [],
    notas: [],
    documentos: [],
    actividades: [],
};
const mutations = {
    updateField,
    updatePanel: (state, payload) => {
        state.prospecto = {...state.prospecto, ...payload};
        state.asesor = {...state.asesor, ...payload.clientes.asesor};
        state.tabs_status = payload.tabs_status;
        state.actividades = payload.actividades;
        const notas = _.filter(payload.acciones, { tipo_accion: "nota" });
        state.notas = notas;
    },
    updatePanelCredito: (state, payload) => {
        state.prospecto = payload.ventas;
        state.asesor = payload.ventas.clientes.asesor;
        state.tabs_status = payload.tabs_status;
        state.actividades = payload.actividades;
        const notas = _.filter(payload.acciones, { tipo_accion: "nota" });
        state.notas = notas;
    },
    updateStep: (state, payload) =>{
        state.step = payload;
    },
    updateTabStep: (state, payload) =>{
        state.tabs_status = payload;
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
